import type React from 'react';
import type { CSSProperties } from 'react';
import { useWordsHappenTheme } from '../../theme';
import styles from './status-pill.module.scss';

export type StatusPillTone = 'sun' | 'paper';

export interface StatusPillProps {
  tone?: StatusPillTone;
  /** A CSS colour for the leading dot, e.g. `var(--wh-coral)`. The dot is decorative. */
  dot?: string;
  children: React.ReactNode;
  className?: string;
}

const TONE_CLASS: Record<StatusPillTone, string> = {
  sun: styles.toneSun,
  paper: styles.tonePaper,
};

/** A small uppercase label in a rounded pill, e.g. a live-players count. */
export const StatusPill: React.FC<StatusPillProps> = ({ tone = 'sun', dot, children, className }) => {
  const { theme } = useWordsHappenTheme();

  const cls = [styles.pill, TONE_CLASS[tone], theme === 'meadow' ? styles.meadow : styles.flat, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls}>
      {dot && <span aria-hidden="true" className={styles.dot} style={{ '--pill-dot': dot } as CSSProperties} />}
      {children}
    </span>
  );
};
